(function() {
  const ADDON_HANDLES = [
    'shipping-protection-1',
    '30-day-extended-warranty-copy'
  ];

  let isRemoving = false;

  function getCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function removeItems(keys) {
    const updates = {};
    keys.forEach(k => updates[k] = 0);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).then(r => r.json());
  }

  function refreshCartDrawer() {
    // Trigger Shrine's native cart drawer refresh
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents();
    } else {
      // Fallback: dispatch Shrine's refresh event
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      // Hard reload as last resort
      setTimeout(() => window.location.reload(), 300);
    }
  }

  function checkAndRemoveAddons() {
    if (isRemoving) return;

    getCart().then(cart => {
      const items = cart.items;
      const addonItems = items.filter(i => ADDON_HANDLES.includes(i.handle));
      if (!addonItems.length) return;

      const hasRealProduct = items.some(i => !ADDON_HANDLES.includes(i.handle));
      if (!hasRealProduct) {
        isRemoving = true;
        const keysToRemove = addonItems.map(i => i.key);
        removeItems(keysToRemove).then(() => {
          refreshCartDrawer();
          setTimeout(() => { isRemoving = false; }, 2000);
        });
      }
    });
  }

  setInterval(checkAndRemoveAddons, 1500);
  checkAndRemoveAddons();
})();
